import { addOnsSlice } from './addOns/slice';
import { alertsSlice } from './alerts';
import { authUserSlice } from './auth';
import { billingInfoSlice } from './billingInfo';
import { billingNavSlice } from './billingNav';
import { broadbandLabelSlice } from './broadbandLabel/broadbandLabelSlice';
import { buyMoreSlice } from './buyMore';
import { buyMoreHistorySlice } from './buyMoreHistory';
import { changePlanSlice } from './changePlan';
import { configSlice } from './config';
import { disconnectSlice } from './disconnect/slice';
import { ecaSlice } from './electronicCustomerAgreement/ecaSlice';
import { errorSlice } from './error';
import { eventSlice } from './events';
import { localeSlice } from './locale';
import { networkSlice } from './network/networkSlice';
import { paymentsSlice } from './payments';
import { pendingInstallationSlice } from './pendingInstallation/pendingInstallationSlice';
import { planSlice } from './plan/planSlice';
import { portfolioSlice } from './portfolio/portfolioSlice';
import { pushNotificationsSlice } from './pushNotifications';
import { registrationSlice } from './registration';
import { scheduleInstallationSlice } from './scheduleInstallation/scheduleInstallationSlice';
import { scrubbedAddressSlice } from './scrubbedAddress';
import { streamOnSlice } from './streamOn';
import { streamOnPromoSlice } from './streamOnPromo';
import { updateAddressSlice } from './updateAddress';
import { updateBillCycleSlice } from './updateBillCycle/slice';
import { historicalUsageInfoSlice } from './usageHistory';
import { userInfoSlice } from './userInfo';
import { workOrdersSlice } from './workOrders/workOrdersSlice';

import { utilsSlice } from './utils';

const reducers = [
  authUserSlice,
  alertsSlice,
  utilsSlice,
  configSlice,
  updateAddressSlice,
  eventSlice,
  streamOnSlice,
  addOnsSlice,
  localeSlice,
  scrubbedAddressSlice,
  errorSlice,
  registrationSlice,
  userInfoSlice,
  historicalUsageInfoSlice,
  streamOnPromoSlice,
  billingInfoSlice,
  billingNavSlice,
  paymentsSlice,
  buyMoreSlice,
  buyMoreHistorySlice,
  changePlanSlice,
  pushNotificationsSlice,
  scheduleInstallationSlice,
  pendingInstallationSlice,
  updateBillCycleSlice,
  portfolioSlice,
  networkSlice,
  planSlice,
  broadbandLabelSlice,
  networkSlice,
  workOrdersSlice,
  disconnectSlice,
  ecaSlice,
];

const rootReducer = reducers.reduce((acc, curr) => {
  return { ...acc, [curr.name]: curr.reducer };
}, {});

export default rootReducer;

type SliceType = (typeof reducers)[number]; // Individual reducers type
type SliceNames = SliceType['name']; // Union of all reducer names

export type RootState = {
  [K in SliceNames]: K extends SliceType['name']
    ? ReturnType<Extract<SliceType, { name: K }>['reducer']>
    : never;
};
